<template>
  <DashboardTemplate :navMenu="true">
    <div class="text-left pd-b-3">
      <h2 class="mg-less">หลักสูตรของฉัน</h2>
    </div>
    <el-tabs v-model="activeName" class="secondary">
      <el-tab-pane label="หลักสูตรที่กำลังเรียน" name="1">
        <el-row v-loading="loading" v-if="studyings.length > 0" :gutter="30">
          <el-col
            v-for="item in studyings"
            :key="item._id"
            :span="24"
            :sm="12"
            :md="8"
            class="pd-y-4"
          >
            <CourseCard
              type="studying"
              :progress="item.percent ? item.percent : 0"
              :pass="
                new Date(item.durationTime.close).getTime() < Date.now()
                  ? item.pass
                  : true
              "
              :id="item._id"
              :image="
                typeof item.illustration != 'undefined'
                  ? item.illustration.file
                  : ''
              "
              :name="item.name"
              :studyId="item.studyId"
              @saveStatusCourse="saveStatusCourse"
            />
          </el-col>
        </el-row>
        <p v-else class="color-gray pd-t-1">*** ไม่พบข้อมูล ***</p>
      </el-tab-pane>
      <el-tab-pane label="หลักสูตรที่ลงทะเบียน" name="2">
        <el-row
          v-loading="loading"
          v-if="registersSort.length > 0"
          :gutter="30"
        >
          <el-col
            v-for="item in registersSort"
            :key="item._id"
            :span="24"
            :sm="12"
            :md="8"
            class="pd-y-4"
          >
            <CourseCard
              type="register"
              :status="item.statusApprove"
              :id="item._id"
              :image="
                typeof item.illustration != 'undefined'
                  ? item.illustration.file
                  : ''
              "
              :name="item.name"
            />
          </el-col>
        </el-row>
        <p v-else class="color-gray pd-t-1">*** ไม่พบข้อมูล ***</p>
      </el-tab-pane>
      <el-tab-pane label="หลักสูตรที่เรียนจบ" name="3">
        <el-row v-loading="loading" v-if="completes.length > 0" :gutter="30">
          <el-col
            v-for="item in completes"
            :key="item._id"
            :span="24"
            :sm="12"
            :md="8"
            class="pd-y-4"
          >
            <CourseCard
              type="graduate"
              :id="item._id"
              :dateEnd="item.successDate"
              :image="
                typeof item.illustration != 'undefined'
                  ? item.illustration.file
                  : ''
              "
              :name="item.name"
            />
          </el-col>
        </el-row>
        <p v-else class="color-gray pd-t-1">*** ไม่พบข้อมูล ***</p>
      </el-tab-pane>
    </el-tabs>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import CourseCard from "@/components/course/CourseCard";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    CourseCard,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },

  computed: {
    token() {
      return this.$store.state.token;
    },
    registersSort() {
      return this.registers.sort((a, b) => {
        if (a.statusApprove == 0) return -1;
        if (a.statusApprove == 1) return 0;
        if (a.statusApprove == 2) return 1;
      });
    },
  },
  data() {
    return {
      activeName: "studying",
      completes: [],
      registers: [],
      studyings: [],
      loading: true,
    };
  },
  mounted() {
    this.setParams();
    this.fetchMyCourse();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.tab != "undefined") {
          this.activeName = this.routeParams.tab;
        }
      }
    },
    fetchMyCourse() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`my/course`)
        .then((res) => {

          if (res.data.success) {
            this.completes = res.data.obj.complete;
            this.registers = res.data.obj.register;
            this.studyings = res.data.obj.studying;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    saveStatusCourse(id) {
      this.loading = true;

      let obj = {
        _id: id,
        statusApprove: 0,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`status/course`, obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchMyCourse();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("saveStatusCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
